import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  toggleSidebar: false,
  toggleFilter: false,
  roleView: localStorage.getItem("roleView") || "admin", 
};

export const toggleSlice = createSlice({
  name: "toggler",
  initialState,
  reducers: {
    setToggleSidebar: (state, action) => {
      state.toggleSidebar = !state.toggleSidebar;
    },
    setToggleFilter: (state, action) => {
      state.toggleFilter = !state.toggleFilter;
    },
    toggleRoleView: (state) => {
      state.roleView = state.roleView === "admin" ? "hr" : "admin";
      localStorage.setItem("roleView", state.roleView);
    },
     setRoleView: (state, action) => {
      state.roleView = action.payload;
      localStorage.setItem("roleView", action.payload);
    },
  },
});

export const { setToggleSidebar, setToggleFilter, toggleRoleView, setRoleView } = toggleSlice.actions;

export default toggleSlice.reducer;
